import React, { useState, useEffect } from 'react';
import Skills from './Skills';

const About = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleFlip = (targetState) => {
    // Same behavior for both mobile and desktop - pure 3D flip
    setIsFlipped(targetState);
  };

  return (
    <div className="left-section">
      <div className={`card-container ${isFlipped ? 'is-flipped' : ''}`}>
        {/* Front of card - Now Skills */}
        <div className="card-face card-front">
          <h1 className="hey">Skills</h1>
          <Skills />
          <div className="pagination-wrapper">
            <div className="pagination-lines">
              <div 
                className={`pagination-button ${!isFlipped ? 'active' : ''}`}
                onClick={() => handleFlip(false)}
              >
                <div className="pagination-line" />
              </div>
              <div
                className={`pagination-button ${isFlipped ? 'active' : ''}`}
                onClick={() => handleFlip(true)}
              >
                <div className="pagination-line" />
              </div>
            </div>
          </div>
        </div>
        
        {/* Back of card - Now About */}
        <div className="card-face card-back">
          <h1 className="hey">About</h1>
          <div className="scroll-container">
            <div className="about">
              <p>My interest in engineering arose not solely from technology in itself; It rather came from the possibilities that technology can create, fostering innovation in all aspects of the human experience.</p>
              <p>This is why I chose to dig my educational roots in a degree with a focus on the congruity of art and engineering. It is the underlying science and mathematics that the ingenuity of great modern technology is built on, but it is the passion of the results of innovation that brought the first Macintosh, the Neve 1073, and the Polaroid camera. It is also this passion that turns engineering into an art in itself.</p>
              <p>I strive to embed this philosophy into my work. Whether I am programming a web app that takes users down informational rabbit-holes of their favorite songs, or I am perfecting the mix of a song so that it's radio ready, the foundations of what I do are best done with the underlying science of each endeavor. But the success of the execution often comes from the driving force: which is what the the manifestation of the work can do to change my life, as well as the lives of others.</p>
            </div>
          </div>
          <div className="pagination-wrapper">
            <div className="pagination-lines">
              <div
                className={`pagination-button ${!isFlipped ? 'active' : ''}`}
                onClick={() => handleFlip(false)}
              >
                <div className="pagination-line" />
              </div>
              <div
                className={`pagination-button ${isFlipped ? 'active' : ''}`}
                onClick={() => handleFlip(true)}
              >
                <div className="pagination-line" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .left-section {
          flex: 1;
          margin: 10px;
          perspective: 1000px;
          padding: 20px;
          height: 100%; /* Changed from 650px to 100% to fill container */
          min-height: 500px;
          text-align: center;
          background: linear-gradient(145deg, #1a1a1a, #0d0d0d);
          border-radius: 20px;
          box-shadow: 
            0 10px 20px rgba(0,0,0,0.4),
            0 6px 6px rgba(0,0,0,0.3),
            inset 0 1px 1px rgba(255,255,255,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .left-section:hover {
          transform: translateY(-5px);
          box-shadow: 
            0 15px 30px rgba(0,0,0,0.5),
            0 10px 10px rgba(0,0,0,0.4),
            inset 0 1px 1px rgba(255,255,255,0.1);
        }

        .card-container {
          position: relative;
          width: 100%;
          flex: 1;
          min-height: 0; /* Important for flex children with absolute positioned content */
          transform-style: preserve-3d;
          transition: transform 0.8s;
        }

        .card-container.is-flipped {
          transform: rotateY(180deg);
        }

        .card-face {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          display: flex;
          flex-direction: column;
        }

        .scroll-container {
          position: relative;
          flex: 1;
          overflow-y: auto;
          margin: 20px 8px;
          margin-top: 0;
          height: calc(100% - 140px);
          scroll-behavior: smooth;
          direction: rtl;
          scrollbar-gutter: stable;
          overscroll-behavior: contain; /* Prevent scroll chaining */
        }

        .about {
          direction: ltr;
          margin-left: 12px;
        }

        .pagination-wrapper {
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .scroll-container::-webkit-scrollbar {
          width: 8px;
          background: transparent;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .scroll-container::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 4px;
        }

        .scroll-container::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.15);
          border-radius: 4px;
          transition: background 0.3s ease;
        }

        .scroll-container:hover::-webkit-scrollbar {
          opacity: 1;
        }

        .scroll-container:hover::-webkit-scrollbar-thumb:hover {
          background: rgba(255, 255, 255, 0.25);
        }

        .card-front {
          transform: rotateY(0deg);
          pointer-events: ${isFlipped ? 'none' : 'auto'};
        }

        .card-back {
          transform: rotateY(180deg);
          pointer-events: ${isFlipped ? 'auto' : 'none'};
        }

        .pagination-lines {
          display: flex;
          justify-content: center;
          gap: 12px;
          position: relative;
          z-index: 2;
        }
        
        .pagination-button {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .pagination-line {
          width: 24px;
          height: 2px;
          background-color: rgba(255, 255, 255, 0.3);
          transition: all 0.3s ease;
        }
        
        .pagination-button.active .pagination-line {
          background-color: white;
        }
        
        .pagination-button:hover .pagination-line {
          background-color: rgba(255, 255, 255, 0.8);
        }

        .hey {
          margin: 6px !important;
          font-size: 20px;
          font-family: 'Eurostile Extended', 'Eurostile', sans-serif;
          flex-shrink: 0;
        }

        .about p {
          text-align: left;
          text-indent: 2em;
          font-size: 14px;
          font-weight: 300;
          margin-bottom: 31px;
          line-height: 1.6;
          color: #e0e0e0;
          font-family: 'Inter', sans-serif;
        }

        .about p:last-child {
          margin-bottom: 0;
        }

        /* Mobile responsive styles */
        @media screen and (max-width: 768px) {
          .left-section {
            margin: 0;
            height: calc(100vh - 145px);
            min-height: calc(100vh - 145px);
            padding: 30px 20px;
            order: 2;
            /* Keep perspective for 3D flip */
            perspective: 1000px;
          }

          .left-section:hover {
            transform: none;
          }

          .card-container {
            /* Keep 3D transform properties for mobile */
            position: relative;
            width: 100%;
            height: 100%;
            min-height: calc(100vh - 205px);
            transform-style: preserve-3d;
            transition: transform 0.8s;
          }

          .card-face {
            /* Keep absolute positioning and backface-visibility for proper 3D flip */
            position: absolute;
            width: 100%;
            height: 100%;
            min-height: calc(100vh - 205px);
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            display: flex;
            flex-direction: column;
          }

          .scroll-container {
            margin: 10px 4px;
            height: calc(100vh - 305px);
            max-height: calc(100vh - 305px);
            overflow-y: auto;
          }

          .about {
            margin-left: 8px;
          }

          .about p {
            font-size: 14.8px;
            text-indent: 1.5em;
            margin-bottom: 20px;
          }

          .hey {
            font-size: 18px !important;
            margin-top: 10px !important;
          }

          .pagination-wrapper {
            height: 40px;
            margin-top: 10px;
          }
        }

        /* Extra small mobile devices */
        @media screen and (max-width: 480px) {
          .left-section {
            padding: 25px 15px;
            height: calc(100vh - 135px);
            min-height: calc(100vh - 135px);
            /* Keep perspective for 3D flip */
            perspective: 1000px;
          }

          .card-container {
            min-height: calc(100vh - 185px);
            /* Keep 3D transform properties */
            transform-style: preserve-3d;
            transition: transform 0.8s;
          }

          .card-face {
            min-height: calc(100vh - 185px);
            /* Keep proper 3D positioning */
            backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
          }

          .scroll-container {
            margin: 8px 2px;
            height: calc(100vh - 265px);
            max-height: calc(100vh - 265px);
          }

          .about {
            margin-left: 4px;
          }

          .about p {
            font-size: 14.8px;
            text-indent: 1em;
            line-height: 1.5;
          }

          .hey {
            font-size: 16px !important;
          }

          .pagination-wrapper {
            height: 35px;
          }
        }
      `}</style>
    </div>
  );
};

export default About;
